import { Component, Input, OnInit } from '@angular/core';
import { TaskFilterService } from '../task-filter-utility.service';

@Component({
  selector: 'kt-task-selection-bar',
  templateUrl: './task-selection-bar.component.html',
  styleUrls: ['./task-selection-bar.component.scss'],
})
export class TaskSelectionBarComponent implements OnInit {
  @Input() groupedByTeam;
  @Input() groupedByTemplate;
  @Input() groupedByTag;
  @Input() fromPatient;
  progressOptions = [
    { label: 'All', value: '', color: 'btn-text-dark btn-hover-bg-secondary' },
    {
      label: 'Overdue',
      value: 'OVERDUE',
      color: 'btn-text-danger btn-hover-bg-danger btn-hover-text-white',
    },
    { label: 'Planned', value: 'PLANNED', color: 'btn-text-warning btn-hover-light-warning' },
    {
      label: 'In Progress',
      value: 'IN_PROGRESS',
      color: 'btn-text-success btn-hover-light-success',
    },
    { label: 'Waiting', value: 'WAITING', color: 'btn-text-info btn-hover-light-info' },
    { label: 'On Hold', value: 'ON_HOLD', color: 'btn-text-danger btn-hover-light-danger' },
  ];

  constructor(private taskFilterService: TaskFilterService) {}

  ngOnInit(): void {
    this.taskFilterService.activeFilter.next(this.progressOptions[0]);

    this.taskFilterService.isDefaultFilteredValue.subscribe((val) => {
      if (val) {
        this.taskFilterService.activeFilter.next(this.progressOptions[0]);
      }
    });
  }
}
